import { type FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../navigate/consts/routes.consts';
import { canAccessStep, getCurrentStep } from '../navigate/store/selectors';
import { useAppDispatch, useAppSelector } from '../store/store';
import { Breadcrumb, type BreadcrumbStep } from './Breadcrumb';
import { clearSelectedSeats, selectedSeatsSelector } from '@modules-seatSelection';
import { ClearSelectedSeatsDialog } from '@shared/ClearSelectedSeatsDialog';

// Предустановленные хлебные крошки для процесса покупки билетов
export const TicketBookingBreadcrumb: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector(getCurrentStep);
  const selectedSeats = useAppSelector(selectedSeatsSelector);
  const [pendingRoute, setPendingRoute] = useState<string | null>(null);

  const isDateSelectionAccessible = useAppSelector(state =>
    canAccessStep(state, AppRoutes.DATE_SELECTION)
  );
  const isSeatsSelectionAccessible = useAppSelector(state =>
    canAccessStep(state, AppRoutes.SEATS_SELECTION)
  );
  const isCheckoutAccessible = useAppSelector(state => canAccessStep(state, AppRoutes.CHECKOUT));

  const steps: BreadcrumbStep[] = [
    {
      title: 'Выбор сеанса',
      route: AppRoutes.DATE_SELECTION,
      isCurrent: currentStep === AppRoutes.DATE_SELECTION,
      isCompleted: isDateSelectionAccessible && currentStep !== AppRoutes.DATE_SELECTION,
    },
    {
      title: 'Выбор мест',
      route: AppRoutes.SEATS_SELECTION,
      isCurrent: currentStep === AppRoutes.SEATS_SELECTION,
      isCompleted: isSeatsSelectionAccessible && currentStep !== AppRoutes.SEATS_SELECTION,
    },
    {
      title: 'Оформление заказа',
      route: AppRoutes.CHECKOUT,
      isCurrent: currentStep === AppRoutes.CHECKOUT,
      isCompleted: isCheckoutAccessible && currentStep !== AppRoutes.CHECKOUT,
    },
  ];

  const handleNavigate = (route: string) => {
    if (
      route === AppRoutes.DATE_SELECTION &&
      currentStep === AppRoutes.SEATS_SELECTION &&
      selectedSeats.length > 0
    ) {
      setPendingRoute(route);
      return;
    }

    navigate(route);
  };

  const handleConfirmNavigate = () => {
    if (!pendingRoute) return;

    dispatch(clearSelectedSeats());
    navigate(pendingRoute);
    setPendingRoute(null);
  };

  return (
    <>
      <Breadcrumb steps={steps} onNavigate={handleNavigate} />
      <ClearSelectedSeatsDialog
        open={Boolean(pendingRoute)}
        title="Очистить выбранные места?"
        description="При возврате к выбору сеанса билеты из корзины будут удалены."
        onCancel={() => setPendingRoute(null)}
        onConfirm={handleConfirmNavigate}
      />
    </>
  );
};
